<div class="mat-dialog-wrapper">
  <div class="dialog-header d-flex justify-space-between align-items-center">
    <h2 mat-dialog-title class="m-0">
      {{ selectedId ? 'Edit' : 'Add' }} {{ isContact ? (tabName || 'Contact')  : 'Examiner' }} Detail
    </h2>
    <button
      mat-button
      class="header-text-close d-flex align-items-center"
      disableRipple
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
    <mat-dialog-content>
      <form [formGroup]="contactDetailForm">
        <div class="sidenav-body">
          <div [ngClass]="selectedContactType !== 3 || !isContact ? 'd-flex gap-20' : ''">
            <div class="form-field" [ngClass]="selectedContactType !== 3 || !isContact ? 'w-230' : ''">
              <p class="fw-bold">Name <span class="text-red">*</span></p>
              <mat-form-field appearance="fill">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  required
                  formControlName="name"
                />
              </mat-form-field>
            </div>
            <div class="form-field w-230" *ngIf="selectedContactType !== 3 || !isContact">
              <p class="fw-bold">Last Name <span class="text-red">*</span></p>
              <mat-form-field appearance="fill">
                <input
                  matInput
                  autocomplete="off"
                  maxlength="320"
                  formControlName="lastName"
                />
              </mat-form-field>
            </div>
            <div class="form-field w-230 d-none" *ngIf="selectedContactType === 3 && isContact">
              <mat-checkbox
                formControlName="ceased"
                class="mt-2"
              >
                Ceased
              </mat-checkbox>
            </div>
          </div>
          <div class="d-flex gap-20" *ngIf="!isContact || (isContact && selectedContactType === 8)">
            <div class="form-field">
              <p class="fw-bold">Firm Name</p>
              <mat-form-field appearance="fill" class="wp-100">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="firmName"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="d-flex gap-20">
            <div class="form-field w-230">
              <p class="fw-bold">Address Line 1</p>
              <mat-form-field appearance="fill">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="address1"
                />
              </mat-form-field>
            </div>
            <div class="form-field w-230">
              <p class="fw-bold">Address Line 2</p>
              <mat-form-field appearance="fill">
                <input
                  matInput
                  formControlName="address2"
                  autocomplete="off"
                  maxlength="320"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">City</p>
              <mat-form-field appearance="fill" class="wp-100">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="city"
                />
              </mat-form-field>
            </div>
          </div>
          
          <div class="d-flex gap-20">
            <div class="form-field w-230">
              <p class="fw-bold">Post Code</p>
              <mat-form-field appearance="fill">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="postCode"
                />
              </mat-form-field>
            </div>
            <div class="form-field w-230">
              <p class="fw-bold">County</p>
              <mat-form-field appearance="fill">
                <input  matInput formControlName="county" autocomplete="off"/>
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex gap-20">
            <div *ngIf="!isContact" class="form-field w-230">
              <p class="fw-bold">Country</p>
              <ng-select
                class="wp-100"
                [disableOptionCentering]="true"
                formControlName="country"
                panelClass="mat-select-position"
              >
                <ng-option *ngFor="let country of countryList" [value]="country.id">{{ country.description }}</ng-option>
              </ng-select>
            </div>
            <div *ngIf="isContact" class="form-field w-230">
              <p class="fw-bold"><span *ngIf="selectedContactType !== 3">Date Appointed</span><span *ngIf="selectedContactType === 3">Start Date</span> <span class="text-red" *ngIf="this.contactDetailForm.get('dateCeased')?.value"> *</span></p>
              <mat-form-field appearance="fill">
                <input [min]="commenceDate"  matInput formControlName="dateAppointed" [matDatepicker]="daDatePicker" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="daDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #daDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngIf="isContact" class="form-field w-230">
              <p class="fw-bold"><span *ngIf="selectedContactType !== 3">Date Ceased</span><span *ngIf="selectedContactType === 3">End Date</span> </p>
              <mat-form-field appearance="fill">
                <input [min]="commenceDate"  matInput formControlName="dateCeased" [matDatepicker]="dcDatePicker" autocomplete="off" [matDatepickerFilter]="dateCeasedFilter"/>
                <mat-datepicker-toggle matSuffix [for]="dcDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dcDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          
            <div class="form-field w-230" *ngIf="!isContact && !tabName">
              <p class="fw-bold">Accounting Body</p>
              <ng-select
                class="wp-100"
                [disableOptionCentering]="true"
                panelClass="mat-select-position"
                formControlName="accountingBody"
                >
                  <ng-option *ngFor="let item of accountingBodies" [value]="item">{{ item }}</ng-option>
              </ng-select>
            </div>

          </div>
        </div>
  
      </form>
    </mat-dialog-content>
    
    <div class="d-flex pb-5 pt-10 hr-top pt-1 mt-5">
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="saveContactDetails()"
      >
        Save
      </button>
      <button
        class="action-button secondary-button"
        mat-dialog-close
        disableRipple
        type="button"
        mat-button
        disableRipple
      >
        Cancel
      </button>
    </div>
</div>
  
  <app-custom-notifications></app-custom-notifications>
  